import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { User } from "model/user";
import { UserVoiceIdeaDialog } from "../uservoice-idea-dialog";
import * as MuiIcons from "@mui/icons-material";
import { styles } from "./style";

interface Props extends WithStyles<typeof styles> {
	user: User;
}

interface State {
	dialogOpen: boolean;
}

class Component extends React.Component<Props, State> {
	public constructor(props: Props) {
		super(props);
		this.state = {
			dialogOpen: false,
		};
	}

	render() {
		const { user, classes = {} } = this.props;
		const { dialogOpen } = this.state;

		return (
			<>
				<Mui.Fab
					color="primary"
					aria-label="feedback"
					className={classes.fab}
					onClick={() => this.setState({ dialogOpen: !dialogOpen })}
				>
					<MuiIcons.EmojiObjects className={classes.icon} />
				</Mui.Fab>

				<UserVoiceIdeaDialog
					open={dialogOpen}
					onClose={() => this.setState({ dialogOpen: false })}
					user={user}
				/>
			</>
		);
	}
}

export const UserVoiceTrigger = withStyles(Component, styles);
